// extracted by css-extract-rspack-plugin
export default {"BetaLabel":"ArrayField-module__BetaLabel__ct2diaZ"};